/*
 * Banner de anúncio global — o "tópico-banner": uma faixa acima
 * do conteúdo, em todas as páginas, com um botão de fechar.
 *
 * Fechar vale para o anúncio, não para sempre: o id dispensado fica no
 * localStorage, e o admin troca o id (o painel faz isso sozinho quando o
 * texto muda) para o banner voltar a aparecer para todo mundo.
 */
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import { forumBool, t } from '../../utils/settings';
const STORAGE_KEY = 'canela.bannerDismissed';

/** Sem id definido no admin, o próprio HTML identifica o anúncio. */
function bannerId(html) {
  const configured = String(app.forum.attribute('canelaBannerId') || '').trim();
  if (configured) return configured;
  let hash = 0;
  for (let index = 0; index < html.length; index++) hash = Math.imul(31, hash) + html.charCodeAt(index) | 0;
  return `h${(hash >>> 0).toString(36)}`;
}
function dismissedId() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}
class AnnouncementBanner extends Component {
  /** Fechado nesta visita, mesmo se o localStorage estiver bloqueado. */
  closed = false;
  view() {
    const html = String(app.forum.attribute('canelaBannerHtml') || '');
    if (!forumBool('canelaBannerEnabled', true) || !html || this.closed) return null;
    const id = bannerId(html);
    if (dismissedId() === id) return null;
    return m("div", {
      className: "CanelaBanner",
      role: "region",
      "aria-label": t('extras.banner.label')
    }, m("div", {
      className: "CanelaBanner-body Post-body"
    }, m.trust(html)), m(Button, {
      className: "Button Button--icon Button--link CanelaBanner-close",
      icon: "fas fa-times",
      "aria-label": t('extras.banner.dismiss'),
      title: t('extras.banner.dismiss'),
      onclick: () => this.dismiss(id)
    }));
  }
  dismiss(id) {
    this.closed = true;
    try {
      localStorage.setItem(STORAGE_KEY, id);
    } catch {
      // Sem armazenamento, fecha só até recarregar a página.
    }
  }
}
export default function installBanner() {
  extend(app, 'mount', function () {
    const content = document.getElementById('content');
    if (!content?.parentElement || document.getElementById('canela-banner')) return;

    // Um nó próprio, irmão do #content: o roteador redesenha o #content a cada
    // página, e o banner continua onde está entre uma e outra.
    const root = document.createElement('div');
    root.id = 'canela-banner';
    root.className = 'CanelaBanner-root';
    content.parentElement.insertBefore(root, content);
    m.mount(root, AnnouncementBanner);
  });
}
flarum.reg.add('ramon-canela', 'forum/features/extras/banner', installBanner);